document.addEventListener("DOMContentLoaded", function () {
  const showMoreLink = document.getElementById("showMoreVariants");
  if (showMoreLink) {
    showMoreLink.addEventListener("click", function () {
      document.querySelectorAll(".hidden-variant").forEach(function (variant) {
        variant.style.display = "block"; // or variant.classList.remove('hidden-variant');
      });
      showMoreLink.style.display = "none"; // Hide the link after expanding
    });
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const content = document.getElementById("description-content");
  const text = document.getElementById("description-text");
  const expandLink = document.getElementById("expand-link");

  // Only run if all elements are found
  if (!content || !text || !expandLink) return;

  // Add toggle behavior
  expandLink.addEventListener("click", (event) => {
    event.preventDefault(); // prevent anchor jump

    if (expandLink.textContent.trim() === "Vis mer") {
      expandLink.textContent = "Vis mindre";
      text.classList.remove("text-clip");
    } else {
      expandLink.textContent = "Vis mer";
      text.classList.add("text-clip");
    }
  });

  // Detect overflow and show/hide the link
  if (text.scrollHeight > content.offsetHeight) {
    expandLink.style.display = "inline";
  } else {
    expandLink.style.display = "none";
  }
});


  document.addEventListener('DOMContentLoaded', function() {
    var redirectUrl = 'https://instinct.no/a/loyalty';
    var currentUrl = window.location.href;
    var urlParams = new URLSearchParams(window.location.search);
    var returnParam = urlParams.get('return_url');

    // Check if the URL path includes '/account/login' and 'return_url' is not present
    if (currentUrl.includes('/account/login') && returnParam === null) {
      window.location.href = redirectUrl;
    }
  });


